export const placeholder = {
  value: 'Значение',
  search: 'Поиск',
  date: {
    start: 'Начальная дата',
    stop: 'Конечная дата',
    end: 'Конечная дата',
    from: 'C',
    to: 'По'
  },
  time: {
    start: 'Начальное время',
    stop: 'Конечное время',
    from: 'C',
    to: 'По'
  }
}

export const word = {
  input: 'инпут',
  server: 'cервер',
  list: 'список',
  member: 'элемент списка',
  members: 'элементы списка',
  preprocessor: 'препроцессор',
  processor: 'процессор',
  postprocessor: 'постпроцессор',
  output: 'вывод',
  information: 'информация',
  current: 'текущий',
  user: 'пользователь',
  users: 'пользователи',
  license: 'лицензия',
  notification: 'уведомлениe',
  logs: 'логи',
  active: 'активен',
  inactive: 'неактивен',
  loading: 'Загрузка',
  cancel: 'Отмена',
  live: 'Активно',
  of: 'из'
}

export const title = {
  notifications: 'Уведомления'
}

export const error = {
  validation: 'Ошибка валидации'
}
